import formsLoader from '@/mixins/loaders/forms-loader';
import entriesLoader from '@/mixins/loaders/entries-loader';

export default {

  mixins: [
    formsLoader,
    entriesLoader,
  ],

  methods: {
    loadEverything(fromDb) {
      this.loadForms(fromDb);
      if (this.$auth.check()) {
        this.loadEntries(fromDb);
      }
    },
  },

  created() {
    this.loadEverything(false);
  },

  mounted() {
    Bus.$on('fetch_forms', () => {
      this.loadEntries(true);
    });
    Bus.$on('fetch_entries', () => {
      this.loadEntries(true);
    });
  },

  beforeDestroy() {
    Bus.$off('fetch_forms');
    Bus.$off('fetch_entries');
  },
};
